export default "__VITE_ASSET__BOMoV56J__"